import React, { useState } from 'react';
import '../css/CheckboxComConfirmacao.css';

function CheckboxComConfirmacao({parameters}) {
  const [nextValue, setNextValue] = useState(false);

  const confirmar = () => {
    // setChecked(nextValue);
    // setShowModal(false);
  };

  const cancelar = () => {
    // setShowModal(false);
  };

  return (
    <div>
      {/* <label>
        <input type="checkbox" checked={checked} onClick={handleCheckboxClick} readOnly />
        Ativo
      </label> */}

      {(
        <div className="modal-overlay">
          <div className="modal">
            {parameters?.message && <h5>{parameters.message}</h5>}
            
            <div className="modal-buttons">
              <button onClick={parameters?.confirm}>{parameters?.confirmLabel || 'Confirmar'}</button>
              <button onClick={parameters?.cancel}>{parameters?.cancelLabel || 'Cancelar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckboxComConfirmacao;
